var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstrutura(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.759,
    height: 51.031,
    viewBox: "0 0 63.759 51.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_986",
    "data-name": "Grupo 986",
    transform: "translate(-248.482 -613.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_953",
    "data-name": "Grupo 953",
    transform: "translate(-451.768 30.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_561",
    "data-name": "Grupo 561",
    transform: "translate(116.923 28.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_547",
    "data-name": "Grupo 547",
    transform: "translate(596.548 558.412)",
    opacity: 0.346
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_457",
    "data-name": "Grupo 457",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    "data-name": "Caminho 207",
    d: "M2.262,25.578,14.62,32.713a4.523,4.523,0,0,1,1.656,6.179l-4.47,7.741H36.119a4.524,4.524,0,0,0,3.918-2.262l9.895-17.137a4.524,4.524,0,0,0-1.656-6.179L35.918,13.92a4.524,4.524,0,0,1-1.657-6.18L38.73,0H14.418A4.523,4.523,0,0,0,10.5,2.262L.606,19.4a4.524,4.524,0,0,0,1.656,6.179",
    transform: "translate(0)",
    fill: "#d9d9d8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_538",
    "data-name": "Grupo 538",
    transform: "translate(-98 -309.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_531",
    "data-name": "Grupo 531",
    transform: "translate(72.564 3.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_527",
    "data-name": "Caminho 527",
    d: "M177.732,64.163h5.361V19.535h14.995v29.74",
    transform: "translate(431.781 841.748)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_108",
    "data-name": "Linha 108",
    x2: 6.177,
    y2: 0.085,
    transform: "translate(629.868 879.61)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_528",
    "data-name": "Caminho 528",
    d: "M219.077,68.582V31.867h15.161V68.582h5.152",
    transform: "translate(416.968 837.33)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_109",
    "data-name": "Linha 109",
    y2: 8.058,
    transform: "translate(629.868 897.854)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_110",
    "data-name": "Linha 110",
    y2: 4.636,
    transform: "translate(622.147 867.792)",
    fill: "none",
    stroke: "#48af77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_111",
    "data-name": "Linha 111",
    y2: 4.636,
    transform: "translate(622.147 879.063)",
    fill: "none",
    stroke: "#48af77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_112",
    "data-name": "Linha 112",
    y2: 4.636,
    transform: "translate(622.147 891.066)",
    fill: "none",
    stroke: "#48af77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_113",
    "data-name": "Linha 113",
    y2: 4.636,
    transform: "translate(643.625 873.378)",
    fill: "none",
    stroke: "#48af77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_114",
    "data-name": "Linha 114",
    y2: 4.636,
    transform: "translate(643.625 885.381)",
    fill: "none",
    stroke: "#48af77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_115",
    "data-name": "Linha 115",
    y2: 4.636,
    transform: "translate(643.625 897.384)",
    fill: "none",
    stroke: "#48af77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrutura);
export default __webpack_public_path__ + "static/media/estrutura.1d630aa206e6ff1a67f22b9bf29e1c4e.svg";
export { ForwardRef as ReactComponent };